module.exports = __webpack_public_path__ + "img/rhenium.decf18e1.jpg";